export interface Shortcut {
  meta: boolean
  shift: boolean
  key: string
}

interface ShortcutKeyProps {
  shortcut: Shortcut
}
export const ShortcutKey: React.FC<ShortcutKeyProps> = ({ shortcut }) => {
  const shortcutKeyClasses =
    'border min-w-5 rounded-sm bg-bg1 text-xs-500 flex items-center justify-center'
  const isDelete = shortcut.key === 'backspace'
  return (
    <div className="flex gap-[3px] text-center">
      {isDelete && <span className={shortcutKeyClasses}>⌫</span>}
      {shortcut.meta && <span className={shortcutKeyClasses}>⌘</span>}
      {shortcut.shift && <span className={shortcutKeyClasses}>⇧</span>}
      {!isDelete && <span className={shortcutKeyClasses}>{shortcut.key.toUpperCase()}</span>}
    </div>
  )
}

export const getShortcutKeyString = (shortcut: Shortcut): string => {
  const isDelete = shortcut.key === 'backspace'
  const parts: string[] = []

  if (isDelete) parts.push('⌫')
  if (shortcut.meta) parts.push('⌘')
  if (shortcut.shift) parts.push('⇧')
  if (!isDelete) parts.push(shortcut.key.toUpperCase())

  return parts.join('')
}
